import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "c-sec__title" }
const _hoisted_2 = { class: "c-item__thumb" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "c-item__time" }
const _hoisted_5 = { class: "c-item__header" }
const _hoisted_6 = { class: "c-item__title" }
const _hoisted_7 = { class: "c-item__like" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  width: "22",
  height: "22"
}, [
  /*#__PURE__*/_createElementVNode("use", { href: "#icon-like" })
], -1)
const _hoisted_9 = {
  key: 0,
  class: "c-tags"
}
const _hoisted_10 = { class: "c-ranks" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14"
}, [
  /*#__PURE__*/_createElementVNode("use", { href: "#icon-cup" })
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "30"
}, [
  /*#__PURE__*/_createElementVNode("use", { href: "#icon-angle-left" })
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "30"
}, [
  /*#__PURE__*/_createElementVNode("use", { href: "#icon-angle-right" })
], -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_ctx.listCourses().length > 0)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(_ctx.classes)
      }, [
        _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.listTitle), 1),
        _createVNode(_component_swiper, {
          "space-between": 10,
          "slides-per-view": 5,
          class: "c-slider j-swiper",
          onSwiper: _ctx.setSwiper
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCourses(), (c) => {
              return (_openBlock(), _createBlock(_component_swiper_slide, {
                key: c.id,
                class: _normalizeClass({'c-item': true, 'is-new': _ctx.isNew(c.release || 0)})
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_router_link, {
                      to: { path: `/course/${c.id}` }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("picture", null, [
                          _createElementVNode("img", {
                            src: c.thumbnail,
                            width: "480",
                            height: "270",
                            alt: ""
                          }, null, 8, _hoisted_3)
                        ]),
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.formatSec(c.duration || 0)), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h3", _hoisted_6, [
                      _createVNode(_component_router_link, {
                        to: { path: `/course/${c.id}` }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(c.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("span", null, _toDisplayString(c.likes ? c.likes.count: 0), 1)
                    ])
                  ]),
                  (c.tags)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.tags.items, (tag, idx) => {
                          return (_openBlock(), _createElementBlock("li", { key: idx }, [
                            _createVNode(_component_router_link, {
                              to: { path: `/tag/${tag.tag.type}/${tag.tag.id}` }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(tag.tag.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("ul", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hasRank(c.id), (label, idx) => {
                      return (_openBlock(), _createElementBlock("li", { key: idx }, [
                        _hoisted_11,
                        _createElementVNode("span", null, _toDisplayString(label), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _: 2
              }, 1032, ["class"]))
            }), 128)),
            _createElementVNode("div", {
              class: "swiper-button-prev",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.swiperSlide('prev')))
            }, _hoisted_13),
            _createElementVNode("div", {
              class: "swiper-button-next",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.swiperSlide('next')))
            }, _hoisted_15)
          ]),
          _: 1
        }, 8, ["onSwiper"])
      ], 2))
    : _createCommentVNode("", true)
}